import { createContext, type ReactNode, useContext } from 'react';
import { useCleanedImageData } from '~/features/background/useCleanedImageData';
import { useStore } from '~/store';
import { useImageBitmap } from './image-utils';

const Ctx = createContext<ImageBitmap | null>(null);

/** Single owner of the cleaned-image GPU bitmap. Step-aware: matte step
 *  renders the live pipeline output; sprite step renders the committed
 *  snapshot so frame work is decoupled from in-flight matte edits. */
export function CleanedBitmapProvider({ children }: { children: ReactNode }) {
  const live = useCleanedImageData();
  const committed = useStore((s) => s.workflow.committedCleaned);
  const step = useStore((s) => s.workflow.step);
  const cleaned = step === 'sprite' && committed ? committed : live;
  const bitmap = useImageBitmap(cleaned);
  return <Ctx.Provider value={bitmap}>{children}</Ctx.Provider>;
}

export function useCleanedBitmap(): ImageBitmap | null {
  return useContext(Ctx);
}
